/**
 * Professions Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    followed: [],
    followUp: {},
    specialtyFollowUp: {}
};

// Getters
const getters = {
    followed: state => {
        return state.followed
    },

    followUp: state => {
        return state.followUp
    },
    specialtyFollowUp: state => {
        return state.specialtyFollowUp
    }
};

// Actions
const actions = {
    getFollowed(context, payload) {
        function successCallback(response) {
            context.commit('getFollowedHandler', { followed: response.data.suivis });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Followed.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getSearchFollowed(context, payload) {
        function successCallback(response) {
            context.commit('getFollowedHandler', { followed: response.data.suivis });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        return makeApiRequest(payload.args, apiModel.Followed.SearchList, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getFollowUp(context, payload) {
        function successCallback(response) {
            context.commit('getFollowUpHandler', { followUp: response.data.suivi });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Followed.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    specialtyFollowUp(context, payload) {
        function successCallback(response) {
            context.commit('getSpecialtyFollowUpHandler', { specialtyFollowUp: response.data.specialiteSuivi });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.SpecialtyFollowed.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createFollowUp(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // Here we add a follow-up to the list of follow-ups
            context.commit('pushFollowedHandler', { followUp: response.data.suivi });

            // we can leave to the route of a tracking display
            // We assume that if there's a view to display a tracker or followed-up, that we call it suivi
            // router.push({ name: 'suivi', params: { suivi: response.data.suivi.slug } });
            // router.push({ name: 'follow-up' });
            router.push({ name: 'follow-up-category', params: {followUpCategorySlug: payload.slugToRedirect} });
        }


        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Followed.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createSpecialtyFollowUp(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // Here we add a follow-up to the list of follow-ups
            context.commit('pushSpecialtyFollowedHandler', { specialtyFollowUp: response.data.specialiteSuivi });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.SpecialtyFollowed.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateFollowUp(context, payload) {
        function successCallback(response) {

            // if (payload.callback) payload.callback();

            if (payload.args.categorie_id != 6){
                Vue.swal(
                    payload.successMessage,
                    '',
                    'success'
                );
            }
            // store.dispatch('findAndRemove', {name: 'suivi' });

            //We assume that if there's a view to display a tracker
            //or followed-up, that we call it suivi
            router.push({ name: 'follow-up-category', params: {followUpCategorySlug: response.data.suivi.categorie.slug} });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.Followed.Create.url + '/' + payload.slug;

        Vue.axios.put(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        //makeApiRequest(payload.args, apiModel.Followed.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateSpecialtyFollowUp(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            context.commit('pushSpecialtyFollowedHandler', { specialtyFollowUp: response.data.specialiteSuivi });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.SpecialtyFollowed.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteFollowUp(context, payload) {
        function successCallback(response) {
            context.commit('deleteFollowUpHandler', { index: payload.index, successMessage: payload.successMessage });

            if (payload.refreshArray) {
                payload.refreshArray(response.data.suivi);
            }
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.Followed.Create.url + '/' + payload.slug;

        Vue.axios.delete(
            url,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.Followed.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteSpecialtyFollowUp(context, payload) {
        function successCallback(response) {
            context.commit('deleteSpecialtyFollowUpHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.SpecialtyFollowed.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getFollowedHandler(state, { followed }) {
        // Update followed state
        state.followed = followed;
    },

    pushFollowedHandler(state, { followUp }) {
        // Update followed state
        state.followed .push(followUp);
    },

    pushSpecialtyFollowedHandler(state, { specialtyFollowUp }) {
        if( state.followUp.hasOwnProperty('specialites'))
        {
            let i = state.followUp.specialites.findIndex(followUp => followUp.slug === specialtyFollowUp.slug);
            if (~i) {
                state.followUp.specialites.splice(i, 1);
                state.followUp.specialites.push(specialtyFollowUp)
            }else{
                state.followUp.specialites.push(specialtyFollowUp)
            }
        }
    },

    getFollowUpHandler(state, { followUp }) {
        // Update followUp state
        state.followUp = followUp;
    },

    deleteFollowUpHandler(state, { index, successMessage }) {
        let i = state.followed.findIndex(followUp => followUp.slug === index);

        if (~i) {
            state.followed.splice(i, 1);

            // After deleting from the list of follow-ups you can go to the listing route
            // if you wish. Please note that if we are on the follow-ups listing page,
            // the list of follow-ups is already updated as of this date.

            //We assume that if there is a view to display the
            // follow-ups, that we call it follow-ups
            router.push({ name: 'suivis' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },

    deleteSpecialtyFollowUpHandler(state, { index, successMessage }) {
        if( state.followUp.hasOwnProperty('specialites'))
        {
            let i = state.followUp.specialites.findIndex(followUp => followUp.slug === index);
            if (~i) {
                state.followUp.specialites.splice(i, 1);
            }
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
